//// LoginPage.js - Dark Mode Ready
//import { useState } from 'react';
//import { Moon, Sun } from 'lucide-react'; // Ako koristiš lucide-react
//import "./LoginPage.css";
//
//export default function LoginPage({
//  loginForm,
//  setLoginForm,
//  handleLogin,
//  loading,
//  theme,        // ← Dodaj ovo iz App.js
//  setTheme      // ← Dodaj ovo iz App.js
//}) {
//  const [showPassword, setShowPassword] = useState(false);
//
//  return (
//    <div className="login-container">
//      {/* Theme Toggle - gornji desni ugao */}
//      <div className="theme-toggle">
//        <button
//          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
//          className="theme-button"
//          aria-label="Toggle theme"
//        >
//          {theme === 'light' ? '🌙' : '☀️'}
//        </button>
//      </div>
//
//      <div className="login-box">
//        <h1 className="login-title">🎁 vouppy Dashboard</h1>
//
//        <input
//          type="text"
//          placeholder="Korisničko ime"
//          value={loginForm.username}
//          onChange={(e) =>
//            setLoginForm({ ...loginForm, username: e.target.value })
//          }
//          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
//          autoCapitalize="none"
//          autoCorrect="off"
//          autoComplete="username"
//        />
//
//        <div className="password-wrapper">
//          <input
//            type={showPassword ? "text" : "password"}
//            placeholder="Lozinka"
//            value={loginForm.password}
//            onChange={(e) =>
//              setLoginForm({ ...loginForm, password: e.target.value })
//            }
//            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
//            autoCapitalize="none"
//            autoCorrect="off"
//            autoComplete="current-password"
//          />
//          <button
//            type="button"
//            className="password-toggle"
//            onClick={() => setShowPassword(!showPassword)}
//            aria-label={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
//          >
//            {showPassword ? '🙈' : '👁️'}
//          </button>
//        </div>
//
//        <button onClick={handleLogin} disabled={loading}>
//          {loading ? "⏳ Učitavanje..." : "Prijavi se"}
//        </button>
//
//        <p className="login-demo">
//          <strong>Za test koristite:</strong> demo / demo123
//        </p>
//      </div>
//    </div>
//  );
//}
// LoginPage.js - Dark Mode Ready
import { useState } from 'react';
import "./LoginPage.css";

export default function LoginPage({
  loginForm,
  setLoginForm,
  handleLogin,
  loading,
  theme,
  setTheme
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="login-container">
      {/* Theme Toggle - gornji desni ugao */}
      <div className="theme-toggle">
        <button
          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
          className="theme-button"
          aria-label="Toggle theme"
        >
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
      </div>

      <div className="login-box">
        <h1 className="login-title">🎁 vouppy Dashboard</h1>

        <input
          type="text"
          placeholder="Korisničko ime"
          value={loginForm.username}
          onChange={(e) =>
            setLoginForm({ ...loginForm, username: e.target.value })
          }
          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          autoCapitalize="none"
          autoCorrect="off"
          autoComplete="username"
        />

        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Lozinka"
            value={loginForm.password}
            onChange={(e) =>
              setLoginForm({ ...loginForm, password: e.target.value })
            }
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="current-password"
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
          >
            {showPassword ? '🙈' : '👁️'}
          </button>
        </div>

        <button onClick={handleLogin} disabled={loading}>
          {loading ? "⏳ Učitavanje..." : "Prijavi se"}
        </button>

        <p className="login-demo">
          <strong>Za test koristite:</strong> demo / demo123
        </p>
      </div>
    </div>
  );
}